/* eslint-disable react/no-array-index-key */
import { memo, useMemo } from "react"
import { Skeleton } from "@/components/ui/skeleton"

export const SkeletonCard = () => (
  <Skeleton className="w-full h-20 rounded-lg" />
)
export const SkeletonCardWithTitle = () => (
  <div className="p-4 bg-white rounded-lg shadow-sm min-h-20 space-y-2 flex flex-col items-start justify-between w-full">
    <Skeleton className="w-full h-6 rounded-lg" />
    <Skeleton className="w-20 h-6 rounded-full" />
  </div>
)
export const SkeletonCardWithDescription = () => (
  <div className="p-4 bg-white rounded-lg shadow-sm flex flex-col justify-between items-start min-h-40 w-full">
    <div className="flex flex-col gap-2 w-full">
      <Skeleton className="w-full h-6 rounded-lg" />
      <Skeleton className="w-full h-10 rounded-lg" />
    </div>
    <Skeleton className="w-20 h-6 rounded-full" />
  </div>
)

export const SkeletonCardList = memo(
  ({
    num = 3,
    type = `card`,
  }: {
    num?: number
    type?: `card` | `card-with-title` | `card-with-description`
  }) => {
    const skeletons = useMemo(
      () =>
        Array.from({ length: num }).map((_, index) => {
          if (type === `card`) return <SkeletonCard key={index} />
          if (type === `card-with-title`)
            return <SkeletonCardWithTitle key={index} />
          if (type === `card-with-description`)
            return <SkeletonCardWithDescription key={index} />
          return <SkeletonCard key={index} />
        }),
      [num, type]
    )

    return <div className="w-full flex items-center gap-4">{skeletons}</div>
  }
)
